import Loader from '../Loader';
import { t } from '@lingui/core/macro';

type LoadingFieldProps = {
  schema: {
    spinner: boolean;
    dots: boolean;
    size: number;
    text: string;
  };
};

const LoadingField = ({
  schema: { spinner: spinner = false, dots: dots = false, size: size = 35, text: text = t`Loading...` },
}: LoadingFieldProps) => {
  let _spinner = !(spinner || dots) ? true : spinner;

  return (
    <Loader spinner={_spinner} dots={dots} size={size}>
      {text}
    </Loader>
  );
};

export default LoadingField;
